angular.module('zc.projects')

.directive 'campaignPanels', (Devise, CampaignStats, Project, currencies) ->
  restrict: 'E'
  scope: {
    project: '='
    campaign: '='
    filters: '='
    isAb: '='
  }
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_panels.html'

  link: (scope, element, attrs) ->
    scope.Devise = Devise
    scope.Project = Project
    scope.currency = currencies[scope.project.currency]
    updateData = ->
      CampaignStats.aggregate
        dimension: 'daily'
        campaign_id: scope.campaign.id
        apikey: scope.campaign.apikey
        start_at: scope.filters.start_at
        end_at: scope.filters.end_at
      .then (campaign_stats) ->
        scope.stats = CampaignStats.groupById(campaign_stats)[scope.campaign.id]
        calculatedInvoiceAmount = CampaignStats.calculateInvoiceAmount(scope.project, scope.campaign, scope.stats)
        _.assign scope.stats,
          invoice_amount: calculatedInvoiceAmount

    scope.$watch 'filters', updateData, true



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/directives/campaign_panels.coffee